import axios from "axios";
import { baseUrl } from "../util";
import { ambitionDeptKey } from "../ApiKey/AmbitionDepartmentKey";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const getDepartments = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/business/departments/`,
      getConfig()
    );

    return {
      data: response.data.data,
      shared: response.data.shared,
      writeAccess: response.data.read_or_write,
    };
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export const createDepartment = async (name, triggerInvalidate, user) => {
  const { createDepartment } = ambitionDeptKey;
  try {
    const response = await axios.post(
      `${baseUrl}/api/business/departments/`,
      { name, user },
      getConfig()
    );
    triggerInvalidate(createDepartment);
    return response.data.data;
  } catch (error) {
    console.error("Error creating department:", error);
    throw error;
  }
};

export const createEffort = async ({
  departmentId,
  name,
  description = null,
  triggerInvalidate,
}) => {
  const { createEfforts } = ambitionDeptKey;
  try {
    const response = await axios.post(
      `${baseUrl}/api/business/departments/${departmentId}/efforts/`,
      { name, description },
      getConfig()
    );
    triggerInvalidate(createEfforts);
    return response.data.data;
  } catch (error) {
    console.error("Error creating effort:", error);
    throw error;
  }
};

export const getEfforts = async (departmentId) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/business/departments/${departmentId}/efforts/`,
      getConfig()
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching efforts:", error);
    throw error;
  }
};

export const updateDepartment = async (
  departmentId,
  name,
  triggerInvalidate
) => {
  const { updateDepartment } = ambitionDeptKey;
  try {
    const response = await axios.put(
      `${baseUrl}/api/business/departments/${departmentId}/`,
      { name },
      getConfig()
    );
    triggerInvalidate(updateDepartment);
    return response.data.data;
  } catch (error) {
    console.error("Error updating department:", error);
    throw error;
  }
};

export const deleteDepartment = async (departmentId, triggerInvalidate) => {
  const { deleteDepartment } = ambitionDeptKey;
  try {
    const response = await axios.delete(
      `${baseUrl}/api/business/departments/${departmentId}/`,
      getConfig()
    );
    if (response.status === 204) {
      triggerInvalidate(deleteDepartment);
    }
  } catch (error) {
    console.error("Error deleting department:", error);
    throw error;
  }
};

export const updateEffort = async (
  departmentId,
  effortId,
  triggerInvalidate,
  name,
  description
) => {
  const { updateEfforts } = ambitionDeptKey;
  try {
    const response = await axios.put(
      `${baseUrl}/api/business/departments/${departmentId}/efforts/${effortId}/`,
      { name, description },
      getConfig()
    );

    triggerInvalidate(updateEfforts);

    return response.data.data;
  } catch (error) {
    console.error("Error deleting effort:", error);
    throw error;
  }
};

export const deleteEffort = async (
  departmentId,
  effortId,
  triggerInvalidate
) => {
  const { deleteEfforts } = ambitionDeptKey;
  try {
    const response = await axios.delete(
      `${baseUrl}/api/business/departments/${departmentId}/efforts/${effortId}/`,
      getConfig()
    );

    if (response.status === 204) {
      triggerInvalidate(deleteEfforts);
    }
  } catch (error) {
    console.error("Error deleting effort:", error);
    throw error;
  }
};
